import fetch from '../../../api/fetch';
import { enqueueSnackbar } from '../snackbar';
import { REDUX_ACTIONS } from '../../../shared/config/constants';

export const epicorSyncCustomers = () => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.EPICOR_RIGS_SYNC_CUSTOMERS_LOADING,
    payload: {
      message: 'Please wait...',
    },
  });

  const body = {
    url: '/customers/sync',
    type: 'POST',
  };

  return fetch
    .post('epicorProxy/epicorProxyPost', body)
    .then((resp) => {
      if (!resp.ok) {
        return Promise.reject(resp);
      }
      return resp.json();
    })
    .then((res) => {
      dispatch({
        type: REDUX_ACTIONS.EPICOR_RIGS_SYNC_CUSTOMERS_IDLE,
        payload: {
          message: res.message || 'Customers Synced Successfully',
        },
      });
    })
    .catch(async (error) => {
      dispatch(
        enqueueSnackbar(
          error.message || 'Error syncing Customers',
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.EPICOR_RIGS_SYNC_CUSTOMERS_ERROR,
        payload: {
          message: error.message || 'Error syncing Customers',
        },
      });
    });
};
